// 申请来源
export const SOURCE_LIST = [
  {
    text: '全部',
    value: 0,
  },
  {
    text: 'Le-Credit',
    value: 1,
  },
  {
    text: 'CRM',
    value: 2,
  },
]

// 审核状态
export const AUDIT_STATUS_OBJ = {
  0: {
    text: '待审核',
    color: 'blue',
  },
  1: {
    text: '待审批',
    color: 'purple',
  },
  2: {
    text: '成功',
    color: 'green',
  },
  3: {
    text: '失败',
    color: 'red',
  },
}

// 审批操作
export const APPROVAL_ACTION_OBJ = {
  PASS: 1,
  REJECT: 2,
}
